import { Component, ElementRef, Input, Optional } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';
import { RouterLink } from '@angular/router';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'gl-footer-app-link',
    templateUrl: './footer-app-link.component.html',
    styleUrls: ['./footer-app-link.component.scss']
})
export class FooterAppLinkComponent {
    @Input() label: string;
    private readonly isNativeIos = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';

    constructor(
        private readonly host: ElementRef<HTMLElement>,
        private applicationFacade: ApplicationFacade,
        @Optional() private readonly routerLink: RouterLink | null
    ) {}

    get role(): 'link' | 'button' {
        return this.routerLink ? 'link' : 'button';
    }

    get mobileMenuOpen(): boolean {
        return this.applicationFacade.isMenuOpen();
    }

    handleKeyboardActivate(event: KeyboardEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.host.nativeElement.click();
    }

    /**
     * Native iOS external keyboard only: handles Tab/Shift+Tab navigation
     */
    handleTabNavigation(event: KeyboardEvent): void {
        if (!this.isNativeIos || event.key !== 'Tab' || !event.currentTarget) {
            return;
        }

        const footerButtons = Array.from(
            this.host.nativeElement
                .closest('ion-footer')
                ?.querySelectorAll<HTMLButtonElement>('gl-footer-app-link button:not([disabled])') ?? []
        );
        const currentButton = event.currentTarget as HTMLButtonElement;
        if (!footerButtons.length) {
            return;
        }

        const currentIndex = footerButtons.indexOf(currentButton);
        if (currentIndex < 0) {
            return;
        }

        const nextButton = footerButtons[event.shiftKey ? currentIndex - 1 : currentIndex + 1];
        if (!nextButton) {
            return;
        }

        event.preventDefault();
        nextButton.focus({ preventScroll: true });
    }
}
